import React, { useEffect, useState } from 'react'
import Sidebar from '../../Components/Sidebar'
import TopHeader from '../../Components/TopHeader'
import BannerPage from '../../Components/Banner'
import { Link } from 'react-router'
import About from './About'
import { useHomeStore } from '../../store/useHomeStore'
import Loader from '../../Components/Loader'
import ServiceArea from './serviceArea'
import MarketArea from './MarketArea'
import DisplayMarketArea from './DisplayMarketArea'
import MarketAreaform from './MarketAreaform'
import Projectstatics from './Projectstatics'
import Capability from './Capability'

const Home = () => {

    let { getHome } = useHomeStore()
    const [loading, setLoading] = useState(false)

    const getHomeDataFunction = async () => {
        setLoading(true)
        await getHome()
        setLoading(false)
    }

    useEffect(() => {
        getHomeDataFunction()
    }, [])
    return (
        <div id="admin-dashboard" className="flex h-[800px] bg-neutral-100">
            <Sidebar />
            <div id="main-content" className="flex-1 flex flex-col overflow-hidden">
                <TopHeader pageName="Home" />
                <div id="content-container" className="flex-1 overflow-auto p-6">
                    <Loader loading={loading}>
                        <BannerPage pageName={'home'} />
                        <About />
                        <ServiceArea />
                        <MarketArea />
                        <DisplayMarketArea />
                        <Projectstatics />
                        <Capability />
                        {/* <MarketAreaform /> */}
                    </Loader>
                </div>
            </div>
        </div>
    )
}

export default Home
